// Components
import { Card, CardBody, CardFooter, CardItem } from 'components/Card';
import { parsedCustomerSignatureSelector } from 'slices/auth.slice';
// Slices
import {
  selectObjectTypesList,
  selectObjectTypesMap,
} from 'slices/objectTypes.slice';
import { useAppSelector } from 'slices/store';
import type { TType } from '@timeedit/types';
import { TEDrawerSection } from '@timeedit/ui-components';
// Types
import type { IProps } from './sections.interface';

const Properties = ({ availabilityRelation, onChange }: IProps) => {
  const objectTypes = useAppSelector(selectObjectTypesList);
  const objectTypeMap = useAppSelector(selectObjectTypesMap);
  const { availabilityTypes = [] } = availabilityRelation;
  const customerSignature = useAppSelector(parsedCustomerSignatureSelector);

  const onAddObjectType = (typeId: string) => {
    onChange('availabilityTypes', [
      ...availabilityTypes,
      { type: Number(typeId), helpType: true },
    ]);
  };

  const onDeleteObjectType = (index: number) => {
    onChange(
      'availabilityTypes',
      availabilityTypes.filter((_, i) => i !== index)
    );
  };

  return (
    <TEDrawerSection label="Properties">
      <Card
        title="Object types"
        tooltip="Object types"
        data-testid="object-type-add"
        footer={
          <CardFooter.DropdownMenu
            menu={{
              items: objectTypes.map((type) => ({
                key: String(type.id),
                label: type.name,
              })),
              onClick: (option) => onAddObjectType(option.key),
            }}
          />
        }
      >
        <CardBody.VirtualList data={availabilityTypes}>
          {(item, index) => {
            const objectType: TType | undefined = objectTypeMap[item.type];
            const availabilityType = availabilityTypes[index];

            return (
              <CardItem.SwitchItem
                label={objectType?.name}
                url={`/${customerSignature}/configuration/object-types?item1=${item.type}`}
                switches={[
                  {
                    key: 'ownObject',
                    label: 'Own object',
                    checked: item.ownObject,
                    onChange: (checked) =>
                      onChange('availabilityTypes', [
                        ...availabilityTypes.slice(0, index),
                        { ...availabilityType, ownObject: checked },
                        ...availabilityTypes.slice(index + 1),
                      ]),
                  },
                  {
                    key: 'userObject',
                    label: 'User objects',
                    checked: item.userObject,
                    onChange: (checked) =>
                      onChange('availabilityTypes', [
                        ...availabilityTypes.slice(0, index),
                        { ...availabilityType, userObject: checked },
                        ...availabilityTypes.slice(index + 1),
                      ]),
                  },
                ]}
                onDelete={() => onDeleteObjectType(index)}
              />
            );
          }}
        </CardBody.VirtualList>
      </Card>
    </TEDrawerSection>
  );
};

export default Properties;
